import { PetRakunoriResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { PetRakunoriModel } from './pet-rakunori.state';

/** StateDetailsActions */
const ACTION_SET = '[PetRakunori] set';
const ACTION_UPDATE = '[PetRakunori] update';
const ACTION_RESET = '[PetRakunori] reset';
const ACTION_FAIL = '[PetRakunori] fail';
const ACTION_CANCEL_REQUEST = '[PetRakunori] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[PetRakunori] set from api';
const ACTION_UPDATE_FROM_API = '[PetRakunori] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setPetRakunori = createAction(ACTION_SET, props<WithRequestId<PetRakunoriModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updatePetRakunori = createAction(ACTION_UPDATE, props<WithRequestId<Partial<PetRakunoriModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetPetRakunori = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelPetRakunoriRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failPetRakunori = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setPetRakunoriFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PetRakunoriResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updatePetRakunoriFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PetRakunoriResponse>>()
);
